(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/pay-numbergames/assets/javascripts/process-data/add-data-to-wagers.js') >= 0) return;  svs.modules.push('/components/numbergames/pay-numbergames/assets/javascripts/process-data/add-data-to-wagers.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const productMapping = svs.numbergames.productMapping;
function addDataToWagers(_ref) {
  let {
    next,
    wagers,
    draws,
    isSyndicate,
    syndicate
  } = _ref;
  const mapBets = _ref2 => {
    let {
      bets
    } = _ref2;
    const mainProductItsId = bets[0].productId;
    return bets.map(bet => {
      var _draws$mainProductIts;
      return _objectSpread(_objectSpread(_objectSpread({}, bet), isSyndicate && {
        betProperties: [...bet.betProperties, 'BOLAG']
      }), {}, {
        drawNum: productMapping.isJoker(bet.productId) ? (_draws$mainProductIts = draws[mainProductItsId].jokerDraw) === null || _draws$mainProductIts === void 0 ? void 0 : _draws$mainProductIts.drawNumber : draws[mainProductItsId].drawNumber
      });
    });
  };
  const getRegCloseDate = _ref3 => {
    let {
      productId
    } = _ref3;
    return new Date(draws[productId].regCloseTime);
  };
  next({
    wagers: wagers.map(wager => _objectSpread(_objectSpread(_objectSpread({}, isSyndicate && {
      syndicate: true,
      syndicateId: syndicate.syndicateId
    }), wager), {}, {
      bets: mapBets(wager)
    })).sort((a, b) => getRegCloseDate(a.bets[0]) - getRegCloseDate(b.bets[0]))
  });
}
svs.numbergames.pay_numbergames.addDataToWagers = addDataToWagers;

 })(window);